<!-- search bar -->
<div class="content-wrap">
    <div class="container">
        <div class="breadcrumb">
            <app-bread-crumb [data]="breadCrumb"></app-bread-crumb>
        </div>
        <div class="title-catalogue d-flex justify-content-between align-items-center">
            <h2 class="d-flex align-items-center gap-2">
                <img
                    width="24"
                    height="24"
                    src="src-ironside/assets/icons/bookmark_black.svg"
                    alt=""
                />
                {{ 'IRONSIDE.my-favourites.MY_FAVOURITES' | translate }}
            </h2>
            <button class="btn-common btn-modal" (click)="createFavorite()">
                {{ 'IRONSIDE.my-favourites.CREATE_LIST' | translate }}
            </button>
        </div>
        <div class="favoris-list">
            <div class="favoris-list-container">
                <ng-container *ngFor="let item of favList">
                    <div (click)="toSearchPage(item)" class="favoris-item">
                        <div class="favoris-image">
                            <ng-container *ngIf="item?.img?.length > 0; else elseTemplateNotImage">
                                <div *ngFor="let obj of item?.img?.slice(0, 2)">
                                    <ng-container *ngIf="obj; else elseTemplate">
                                        <img
                                            [src]="obj"
                                            [alt]="obj"
                                            width="133"
                                            height="133"
                                            style="object-fit: contain"
                                        />
                                    </ng-container>
                                    <ng-template #elseTemplate>
                                        <span>{{ 'common.no-images-available' | translate }}</span>
                                    </ng-template>
                                </div>
                            </ng-container>
                            <ng-template #elseTemplateNotImage>
                                <span>{{ 'common.no-images-available' | translate }}</span>
                            </ng-template>
                        </div>
                        <div class="favoris-body d-flex justify-content-between align-items-center">
                            <span style="cursor: pointer">{{ item.name }}</span>
                            <div class="wrap-group d-flex align-items-center gap-1">
                                <span
                                    class="btn-edit"
                                    style="cursor: pointer"
                                    (click)="editFavorite(item, $event)"
                                    ><i class="pi pi-pencil"></i
                                ></span>
                                <a class="btn-delete" (click)="deleteFavorite(item.id, $event)"
                                    ><img src="/src-ironside/assets/icons/trash-icon.svg" alt=""
                                /></a>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </div>
            <ng-container *ngIf="loading && !shouldShowSpinner">
                <div class="secsion-loading">
                    <mat-spinner [color]="'#fbba00'" [diameter]="60"></mat-spinner>
                </div>
            </ng-container>

            <ng-container *ngIf="!loading && !favList?.length">
                <div class="no-data">
                    <span>{{ 'IRONSIDE.my-favourites.NO_DATA' | translate }}</span>
                </div>
            </ng-container>
        </div>
    </div>
</div>

<p-toast></p-toast>
<p-confirmPopup></p-confirmPopup>
